import {
  ServiceRequestsApi,
  ReportsApi,
  ReportsResponse,
  ReportPreference,
  ServiceRequestPostRequest,
} from 'cmp-client-api';

import type { ReportsServiceInterface } from '@src/server';
import type { MapperInterface } from '@src/server/converters/types/mapper.interface';
import type { ReportRequestInterface, ServiceRequestInterface } from '@src/domain/types';

export class ReportsService implements ReportsServiceInterface {
  private readonly service: ReportsApi;

  private readonly serviceRequestsApi: ServiceRequestsApi;

  private readonly serviceRequestMapper: MapperInterface<
    ReportRequestInterface,
    ServiceRequestPostRequest
  >;

  public constructor(
    service: ReportsApi,
    serviceRequestMapper: MapperInterface<ReportRequestInterface, ServiceRequestPostRequest>,
    serviceRequestsApi: ServiceRequestsApi
  ) {
    this.service = service;
    this.serviceRequestMapper = serviceRequestMapper;
    this.serviceRequestsApi = serviceRequestsApi;
  }

  public async getReports(): Promise<ReportsResponse> {
    const response = await this.service.getReports();
    return response.data;
  }

  public async postRequests(body: ReportRequestInterface): Promise<ServiceRequestInterface> {
    const transformedRequest = this.serviceRequestMapper.transformToApiModel(body);
    const response = await this.serviceRequestsApi.createServiceRequest(
      undefined,
      transformedRequest
    );

    return {
      ...response.data.data,
      supportSystem: response.data.data.serviceNow,
    };
  }

  public async getReportPreferences() {
    const response = await this.service.getReportPreferences();

    return response.data.reportPreferences;
  }

  public patchReportPreferences(updatedReportpreferences: ReportPreference[]) {
    return this.service.saveReportPreferences({
      reportPreferences: updatedReportpreferences,
    });
  }
}
